import { combineReducers } from "redux";
import loginReducer from "./loginReducer";
import sendMoneyReducer from "./sendMoneyReducer";
import requestMoneyReducer from "./requestMoneyReducer";
import getWithdrawDetailsReducer from "./getWithdrawDetailsReducer";
import transactionHistReducer from "./transactionHistReducer";
import signupReducer from "./signupReducer";
import loadingReducer from "./loadingReducer";
import profileReducer from "./profileReducer";
import activityLogsReducer from "./activityLogsReducer";
import changePasswordReducer from "./changePasswordReducer";
import pendingListReducer from "./pendingListReducer";
import loyaltyPointsReducer from "./loyaltyPointsReducer";
import redeemLoyaltyPointsReducer from "./redeemLoyaltyPointsReducer";
import processingReducer from "./processingReducer";
import withdrawMoneyReducer from "./withdrawMoneyReducer";
import getPaymentModesReducer from "./getPaymentModesReducer";
import upgradeWalletReducer from "./upgradeWalletReducer";
import showCardReducer from "./showCardReducer";
import cardReducer from "./cardReducer";
import showDashboardDetailsReducer from "./showDashboardDetailsReducer";
import regenerateSecretKeyReducer from "./regenerateSecretKeyReducer";
import addBalanceReducer from "./addBalanceReducer";
import currencyConverterReducer from "./currencyConverterReducer";
import deleteCardReducer from "./deleteCardReducer";
import operationsReducer from "./operationsReducer";
import changeLanguageReducer from "./changeLanguageReducer";
import insertOtpReducer from "./insertOtpReducer";
import showWalletBalanceReducer from "./showWalletBalanceReducer";
import sendOtpReducer from "./sendOtpReducer";
import verifyOtpReducer from "./verifyOtpReducer";
import deleteProfilePicReducer from "./deleteProfilePicReducer";
import payReducer from "./payReducer";
import forgotPasswordReducer from "./forgotPasswordReducer";
import kycDocListReducer from "./kycDocListReducer";
import loadLimitReducer from "./loadLimitReducer";
import getKycDetailsReducer from "./getKycDetailsReducer";
import walletSettingReducer from "./walletSettingReducer";
import defaultCurrencyListReducer from "./defaultCurrencyListReducer";
import walletReducer from "./walletReducer";
import signupCurrencyList from "./currencyListReducer";
import getPrepaidCardReducer from "./getPrepaidCardReducer";
import applyPrepaidCardReducer from "./applyPrepaidCardReducer";
import walletToWalletTransferReducer from "./walletToWalletTransferReducer";
import cardBlockUnblockReducer from "./cardBlockUnblockReducer";
import directLoadReducer from "./directLoadReducer";
import bankTransferReducer from "./bankTransferReducer";
import loadMoneyToPrepaidCardReducer from "./loadMoneyToPrepaidCardReducer";
import prepaidCardBalanceReducer from "./prepaidCardBalanceReducer";
import sendCvvBySmsReducer from "./sendCvvBySmsReducer";
import sendPinBySmsReducer from "./sendPinBySmsReducer";
import sendPinByEmailReducer from "./sendPinByEmailReducer";
import cardHolderDetailsReducer from "./cardHolderDetailsReducer";
import virtualToPhysicalCardReducer from "./virtualToPhysicalCardReducer";
import prepaidCardStatementReducer from "./prepaidCardStatementReducer";
import activateCardReducer from "./activatePrepaidCardReducer";
import getBankListReducer from "./getBankListReducer";
import addBankReducer from "./addBankReducer";
import updateCardHolderReducer from "./updateCardHolderReducer";
import walletRolesReducer from "./walletRolesReducer";
import walletListDetailReducer from "./walletListDetailReducer";
import productListReducer from "./productListReducer";
import addressListReducer from "./addressListReducer";
import saveAddressReducer from "./saveAddressReducer";
import addProductCartReducer from "./addProductCartReducer";
import cartListReducer from "./cartListReducer";
import marketPlaceCategoriesReducer from "./marketPlaceCategoriesReducer";
import bankPayoutReducer from "./bankPayoutReducder";
import removeProductCartReducer from "./removeProductCartReducer";
import deleteAddressReducer from "./deleteAddressReducer";
import promoCodeReducer from "./promoCodeReducer";
import vendorProductsReducer from "./vendorProductsReducer";
import deleteVendorProductReducer from "./deleteVendorProductReducer";
import uploadProductReducer from "./uploadProductReducer";
import editVendorProductReducer from "./editVendorProductReducer";
import ordersSellReportReducer from "./ordersSellReportReducer";
import ordersListReducer from "./ordersListReducer";
import orderStatusChangeReducer from "./orderStatusChangeReducer";
import checkoutLoginReducer from "./checkoutLoginReducer";
import getCheckoutPaymentDetailsReducer from "./getCheckoutPaymentDetailsReducer";
import buyProductReducer from "./buyProductReducer";
import myOrdersReducer from "./myOrdersReducer";
import cancelPurOrderReducer from "./cancelPurOrderReducer";
import cashoutReducer from "./cashoutReducer";
import getReceiverReducer from "./getReceiverReducer";
import getUserDetailsReducer from "./getUserDetailsReducer";
import cashinReducer from "./cashinReducer";
import payorderReducer from "./payorderReducer";
import payorderListReducer from "./payorderListReducer";
import payorderOTPReducer from "./payorderOTPReducer";
import deletePayorderReducer from "./deletePayOrderReducer";
import verifyPayorderReducer from "./verifyPayorderReducer";
import checkoutPaymentReducer from "./checkoutPaymentReducer";
import getFeeChargeReducer from "./getFeeChargeReducer";
import showDashboardFeeDetailsReducer from "./showDashboardFeeDetailsReducer";
import verifyMobileReducer from "./verifyMobileReducer";
import cancelCheckoutPaymentReducer from "./cancelCheckoutPaymentReducer";
import bulkUploadReducer from "./bulkUploadReducer";
import logoutReducer from "./logoutReducer";
import getProfileDetailsReducer from "./getProfileDetailsReducer";
import addOrUpdateBusinessPersonReducer from "./addUpdateBusinessPersonReducer";
import verifyQrUniqueIdReducer from "./verifyQrUniqueIdReducer";
import transactionReportReducer from "./transactionReportReducer";
import tpBankListReducer from "./tpBankListReducer";
import tpGetDDTReducer from "./tpGetDDTReducer";
import tpBranchListReducer from "./tpBranchListReducer";
import pendingRequestCountReducer from "./pendingRequestCountReducer";
import tpGetPostalCodesReducer from "./tpGetPostalCodesReducer";
import frontImageOcrReducer from "./frontImageOcrReducer";
import backImageOcrReducer from "./backImageOcrReducer";
import uacsReducer from "./uacsReducer";
import checkoutVoucherReducer from "./checkoutVoucherReducer";

import voucherRateReducer from "./getvoucherRateReducer";
import myvoucherReducer from "./myvoucherReducer";
import { LOGOUT_SUCCESS } from "../types";
import voucherTransactionReducer from "./voucherTransactionReducer";
import VoucherDetailsReducer from "./getVoucherDetailsReducer";
import TransactionDetailsReducer from "./getTransactionDetailsReducer";
import voucherDashboardDetailsReducer from "./voucherDashboardDetailsReducer";
import merchantDashboardDetailsReducer from "./merchantDashboardDetailsReducer";
import merchantDashboardPercurrencyReducer from "./merchantDashboardPercurrencyReducer";
import settlementReportReducer from "./settlementReportReducer";
import settlementDetailsReducer from "./settlementDetailsReducer";
import settlementReportFileReducer from "./settlementReportFileReducer";
import generateMerchantKeyReducer from "./generateMerchantKeyReducer";
import getMerchantKeyReducer from "./getMerchantKeyReducer";
import purchaseVoucherzReducer from "./purchaseVoucherzReducer";
import transactionPasswordSetReducer from "./transactionPasswordSetReducer";
import setTransactionPasswordReducer from "./setTransactionPasswordReducer";
import changeTransactionPasswordReducer from "./changeTransactionPasswordReducer";
import forgotTransactionPasswordReducer from "./forgotTransactionPasswordReducer";
import transactionRefundReducer from "./transactionRefundReducer";
import loginRoleReducer from "./loginRoleReducer";
import partnerLoginReducer from "./partnerLoginReducer";
import authTokenReducer from "./authTokenReducer";
import regenerateTokenReducer from "./regenerateTokenReducer";
import adminLogoutReducer from "./adminLogoutReducer";
import modulesForPartnerReducer from "./modulesForPartnerReducer";
import partnerChangePasswordReducer from "./partnerChangePasswordReducer";
import partnerForgotPasswordReducer from "./partnerForgotPasswordReducer";
import customerListReducer from "./customerListReducer";
import partnerWalletRolesReducer from "./partnerWalletRolesReducer";
import walletAcRequiredReducer from "./walletAcRequiredReducer";
import individualEntityReducer from "./individualEntityReducer";
import organizationTypeReducer from "./organizationTypeReducer";
import businessTypeReducer from "./businessTypeReducer";
import adminCurrencyListReducer from "./adminCurrencyListReducer";
import legalEntityReducer from "./legalEntityReducer";
import adminAuthTokenReducer from "./adminAuthTokenReducer";
import getManualDepositListReducer from "./getManualDepositListReducer";
import getAddManualAmountReducer from "./getAddManualAmountReducer";
import getCustomerWalletCurrencyListReducer from "./getCustomerWalletCurrencyListReducer";
import getLoginBlockListReducer from "./getLoginBlockListReducer";
import unLockAccountReducer from "./unLockAccountReducer";
import getCustomerListReducer from "./getCustomerListReducer";
import getCustomerDetailsReducer from "./getCustomerDetailsReducer";
import updateCustomerDetailsReducer from "./updateCustomerDetailsReducer";
import getOperationListReducer from "./getOperationListReducer";
import blockCustomerOperationsListReducer from "./blockCustomerOperationsListReducer";
import getBlockCustomerOperationsListReducer from "./getBlockCustomerOperationsListReducer";
import unBlockCustomerOperationReducer from "./unBlockCustomerOperationReducer";
import getManualOtpListReducer from "./getManualOtpListReducer";
import closedManualOtpRequestListReducer from "./closedManualOtpRequestListReducer";
import getKYCAccountTypeListReducer from "./getKYCAccountTypeListReducer";
import getManualUpgradeKycListReducer from "./getManualUpgradeKycListReducer";
import sidebarReducer from "./sidebarReducer";
import approveOrRejectManualUpgradeKYCReducer from "./approveOrRejectManualUpgradeKYCReducer";
import addNewWalletForCustomerListReducer from "./addNewWalletForCustomerListReducer";
import getAllWalletsListReducer from "./getAllWalletsListReducer";
import getCustomerIdAndNameListReducer from "./getCustomerIdAndNameListReducer";
import updateCustomerWalletListReducer from "./updateCustomerWalletListReducer";
import getCustomerOwnerDetailsReducer from "./getCustomerOwnerDetailsReducer";
import createFeeWalletReducer from "./createFeeWalletReducer";
import getVoucherMappingListReducer from "./getVoucherMappingListReducer";
import deleteVoucherMappingReducer from "./deleteVoucherMappingReducer";
import addNewVoucherMappingReducer from "./addNewVoucherMappingReducer";
import getVoucherTransactionListReducer from "./getVoucherTransactionListReducer";
import getVoucherTransactionDetailsListReducer from "./getVoucherTransactionDetailsListReducer";
import getVoucherListReducer from "./getVoucherListReducer";
import voucherDetailsReducer from "./voucherDetailsReducer";
import getVoucherRedeemListReducer from "./getVoucherRedeemListReducer";
import getVoucherRedeemDetailsReducer from "./getVoucherRedeemDetailsReducer";
import riskRulesListReducer from "./riskRulesListReducer";
import updateRiskRulesReducer from "./updateRiskRulesReducer";
import rulesMappingReducer from "./rulesMappingReducer";
import allowDisallowCountryReducer from "./allowDisallowCountryReducer";
import blockUnblockCountryReducer from "./blockUnblockCountryReducer";
import getCurrencyMasterListReducer from "./getCurrencyMasterListReducer";
import updateCurrencyMasterListReducer from "./updateCurrencyMasterListReducer";
import uploadSampleFileOfCurrencyRateReducer from "./uploadSampleFileOfCurrencyRateReducer";
import downloadSampleFileOfCurrencyRateReducer from "./downloadSampleFileOfCurrencyRateReducer";
import getWalletTransactionListReducer from "./getWalletTransactionListReducer";
import getTransactionTypeListReducer from "./getTransactionTypeListReducer";
import getOperationLogsListReducer from "./getOperationLogsListReducer";
import gateLoyaltyPointOperationsListReducer from "./gateLoyaltyPointOperationsListReducer";
import getLoyaltyPointsListReducer from "./getLoyaltyPointsListReducer";
import createOrUpdateLoyaltyPointReducer from "./createOrUpdateLoyaltyPointReducer";
import generateWalletTransactionReportFileReducer from "./generateWalletTransactionReportFileReducer";
import getSummeryReportListReducer from "./getSummeryReportListReducer";
import getSummeryReportFileReducer from "./getSummeryReportFileReducer";
import getFeeReportListReducer from "./getFeeReportListReducer";
import getFeeReportFileReducer from "./getFeeReportFileReducer";
import getWithdrawLimitListReducer from "./getWithdrawLimitListReducer";
import addNewWithdrawLimitReducer from "./addNewWithdrawLimitReducer";
import getUserWithdrawLimitListReducer from "./getUserWithdrawLimitListReducer";
import getWithdrawalCountReducer from "./getWithdrawalCountReducer";
import getUserWithdrawalCountReducer from "./getUserWithdrawalCountReducer";
import getLoadLimitListReducer from "./getLoadLimitListReducer";
import addOrUpdateUserWithdrawLimitReducer from "./addOrUpdateUserWithdrawLimitReducer";
import updateUserWithdrawCountReducer from "./updateUserWithdrawCountReducer";
import addOrUpdateLoadLimtiReducer from "./addOrUpdateLoadLimtiReducer";
import getBlockCountryListReducer from "./getBlockCountryListReducer";
import getAllowCountryListReducer from "./getAllowCountryListReducer";
import updateWithdrawalCountReducer from "./updateWithdrawalCountReducer";
import updateLoadCountReducer from "./updateLoadCountReducer";
import getFeeManagementListReducer from "./getFeeManagementListReducer";
import updateFeeManagementListReducer from "./updateFeeManagementListReducer";
import getWalletDashboardReducer from "./getWalletDashboardReducer";
import getWayTransactionListReducer from "./getWayTransactionListReducer";
import viewTransactionDetailsReducer from "./viewTransactionDetailsReducer";
import getKycReportListReducer from "./getKycReportListReducer";
import viewKycDetailsReducer from "./viewKycDetailsReducer";
import getWalletOwnerBankDetailsReducer from "./getWalletOwnerBankDetailsReducer";
import getViewWalletOwnerBankDetailsReducer from "./getViewWalletOwnerBankDetailsReducer";
import updateoraddwalletownerbankdetailsReducer from "./updateoraddwalletownerbankdetailsReducer";
import getViewCongigurationListReducer from "./getViewCongigurationListReducer";
import getwalletownerconfigurationlistReducer from "./getwalletownerconfigurationlistReducer";
import getStoreListReducer from "./getStoreListReducer";
import getKycConfigurationListReducer from "./getKycConfigurationListReducer";
import deleteKycConfigurationRecordReducer from "./deleteKycConfigurationRecordReducer";
import getWalletOwnerSmsProviderReducer from "./getWalletOwnerSmsProviderReducer";
import getKycApproveRejectReducer from "./getKycApproveRejectReducer";
import getInvoiceReducer from "./getInvoiceReducer";
import getUpdateConfigurationListReducer from "./getUpdateConfigurationListReducer";
import commonCfgDetailsReducer from "./commonCfgDetailsReducer";
import getUpdateComDetailsReducer from "./getUpdateComDetailsReducer";
import updateInvoiceConfigReducer from "./updateInvoiceConfigReducer";
import partnerModuleAllocationReducer from "./partnerModuleAllocationReducer";
import invoiceRegenerationReducer from "./invoiceRegenerationReducer";
import getInvoiceConfigReducer from "./getInvoiceConfigReducer";
import getWalletOwnerAndNameListApiReducer from "./getWalletOwnerAndNameListApiReducer";
import getFeeManagementOperationListReducer from "./getFeeManagementOperationListReducer";
import getFeeNameListReducer from "./getFeeNameListReducer";
import getOrderIdReducer from "./getOrderIdReducer";
import getRuleMappingCheckReducer from "./getRuleMappingCheckReducer";
import addUpdateKycConfReducer from "./addUpdateKycConfReducer";
import getKycConfigurationDetailsReducer from "./getKycConfigurationDetailsReducer";
import getKycConfigurationIdReducer from "./getKycConfigurationIdReducer";
import getUserManagementListReducer from "./getUserManagementListReducer";
import getViewUserManagementListReducer from "./getViewUserManagementListReducer";
import getDeleteUserManagementListReducer from "./getDeleteUserManagementListReducer";

// SuperAdmin
import getWalletOwnerReducer from "./getWalletOwnerReducer";
import deleteWalletOwnerReducer from "./deleteWalletOwnerReducer";
import createOrUpdateWalletOwnerReducer from "./createOrUpdateWalletOwnerReducer";
import getThemeListReducer from "./getThemeListReducer";
import getBusinessNatureListReducer from "./getBusinessNatureListReducer";
import addorUpadateBusinessNatureReducer from "./addorUpadateBusinessNatureReducer";
import getEntityTypeListReducer from "./getEntityTypeListReducer";
import addOrUpdateEntityTypeListReducer from "./addOrUpdateEntityTypeListReducer";
import getWalletOwnerIdAndNameListReducer from "./getWalletOwnerIdAndNameListReducer";
import getEntityMappingListReducer from "./getEntityMappingListReducer";
import createEntityMappingReducer from "./createEntityMappingReducer";
import deleteEntityMappingReducer from "./deleteEntityMappingReducer";
import getRoleListReducer from "./getRoleListReducer";
import getMappingRoleListReducer from "./getMappingRoleListReducer";
import getBusinessNatureMappingListReducer from "./getBusinessNatureMappingListReducer";
import createRoleMappingReducer from "./createRoleMappingReducer";
import deleteRoleMappingReducer from "./deleteRoleMappingReducer";
import getParentRoleListReducer from "./getParentRoleListReducer";
import addOrUpdateRoleReducer from "./addOrUpdateRoleReducer";
import getRoleListTableReducer from "./getRoleListTableReducer";
import getRoleListV1Reducer from "./getRoleListV1Reducer";
import getEntityTypeListTableReducer from "./getEntityTypeListTableReducer";
import adminGetIntegrationTypeListReducer from "./adminGetIntegrationTypeListReducer";
import adminGetIntegrationListReducer from "./adminGetIntegrationListReducer";
import adminDeleteIntegrationReducer from "./adminDeleteIntegrationReducer";
import adminAddIntegrationReducer from "./adminAddIntegrationReducer";
import adminGetRiskRuleListReducer from "./adminGetRiskRuleListReducer";
import adminAddRiskRuleReducer from "./adminAddRiskRuleReducer";
import adminRiskRuleMappingReducer from "./adminRiskRuleMappingReducer";
import adminCreateRiskRuleMappingReducer from "./adminCreateRiskRuleMappingReducer";
import adminGetCurrencyMasterReducer from "./adminGetCurrencyMasterReducer";
import adminAddOrUpdateCurrencyReducer from "./adminAddOrUpdateCurrencyReducer";
import adminCreateCurrencyMappingReducer from "./adminCreateCurrencyMappingReducer";
import adminGetCurrencyMappingReducer from "./adminGetCurrencyMappingReducer";
import adminDeleteCurrencyMappingReducer from "./adminDeleteCurrencyMappingReducer";
import adminGetKycActionTypeReducer from "./adminGetKycActionTypeReducer";
import adminGetKycProofListReducer from "./adminGetKycProofListReducer";
import adminAddOrUpdateKycProofReducer from "./adminAddOrUpdateKycProofReducer";
import adminGetKycDocumentListReducer from "./adminGetKycDocumentListReducer";
import adminAddOrUpdateKycDocumentReducer from "./adminAddOrUpdateKycDocumentReducer";
import adminGetFeeMasterListReducer from "./adminGetFeeMasterListReducer";
import adminGetFeeDefaultValuesReducer from "./adminGetFeeDefaultValuesReducer";
import adminGetFeeOperationTypeReducer from "./adminGetFeeOperationTypeReducer";
import adminAddOrUpdateFeeReducer from "./adminAddOrUpdateFeeReducer";
import adminCreateFeeMappingReducer from "./adminCreateFeeMappingReducer";
import adminGetFeeMappingReducer from "./adminGetFeeMappingReducer";
import adminAddOrUpdateKycMappingReducer from "./adminAddOrUpdateKycMappingReducer";
import getWalletOwnerSettingDetailsReducer from "./getWalletOwnerSettingDetailsReducer";
import updateWalletOwnerSettingDetailReducer from "./updateWalletOwnerSettingDetailsReducer";
import createBusinessNatureMappingReducer from "./createBusinessNatureMappingReducer";
import deleteBusinessNatureMappingReducer from "./deleteBusinessNatureMappingReducer";
import getKybReportListReducer from "./getKybReportListReducer";
import getKybDetailsListReducer from "./getKybDetailsListReducer";
import getKybApproveRejectReducer from "./getKybApproveRejectReducer";
import adminGenerateKeyReducer from "./adminGenerateKeyReducer";
import adminKycMappingListReducer from "./adminKycMappingListReducer";
import adminLoyaltyPointOperationReducer from "./adminLoyaltyPointOperationReducer";
import adminGetLoyaltyPointReducer from "./adminGetLoyaltyPointReducer";
import adminAddOrUpdateLoyaltyPointReducer from "./adminAddOrUpdateLoyaltyPointReducer";
import getBusinessNatureTableListReducer from "./getBusinessNatureTableListReducer";
import adminModuleAllocaionReducer from "./adminModuleAllocaionReducer";
import adminUpdateModuleAllocationReducer from "./adminUpdateModuleAllocationReducer";
import adminCurrencyCodeReducer from "./adminCurrencyCodeReducer";
import adminAllocatedModuleReducer from "./adminAllocatedModuleReducer";
import adminAddNewBankReducer from "./adminAddNewBankReducer";
import adminGetBankReducer from "./adminGetBankReducer";
import adminGetBankNameListReducer from "./adminGetBankNameListReducer";
import adminGetMappingBankListReducer from "./adminGetMappingBankListReducer";
import dealerGetListDsrMasterReducer from "./dealerGetListDsrMasterReducer";
import dealerGetListDsrTransactionReducer from "./dealerGetListDsrTransactionReducer";
import dealerSetDsrlimitsReducer from "./dealerSetDsrlimitsReducer";
import dealerDsrListReducer from "./dealerDsrListReducer";
import dealerViewDsrListReducer from "./dealerViewDsrListReducer";
import uploadSampleFileOfDealerDsrLimitReducer from "./uploadSampleFileOfDealerDsrLimitReducer";
import dealerSampleFileReducer from "./dealerSampleFileReducer";
import dealerDsrMappingListReducer from "./dealerDsrMappingListReducer";
import dealerDeleteDsrReducer from "./dealerDeleteDsrReducer";
import dealerAddEditDsrReducer from "./dealerAddEditDsrReducer";
import dealerMultipleMappingListReducer from "./dealerMultipleMappingListReducer";
import dealerAgentDownloadSampleFileReducer from "./dealerAgentDownloadSampleFileReducer";
import dealerUploadAgentFileReducer from "./dealerUploadAgentFileReducer";
import dealerAgentProfileReducer from "./dealerAgentProfileReducer";
import dealerChangeDsrMasterPasswordReducer from "./dealerChangeDsrMasterPasswordReducer";
import dealerBlockDsrMasterReducer from "./dealerBlockDsrMasterReducer";
import dealerAddUpdateDsrLimitsReducer from "./dealerAddUpdateDsrLimitsReducer";
import getMerchantWireListReducer from "./getMerchantWireListReducer";
import editMerchantWireReducer from "./editMerchantWireReducer";
import getManualSettlementReducer from "./getManualSettlementReducer";
import getChargeMasterListReducer from "./getChargeMasterListReducer";
import getMerchantChargeListReducer from "./getMerchantChargeListReducer";
import merchantHistoryReducer from "./merchantHistoryReducer";
import dealerAddUpdateDivisionListReducer from "./dealerAddUpdateDivisionListReducer";
import dealerAddUpdateDistrictListReducer from "./dealerAddUpdateDistrictListReducer";
import dealerAddUpdateThanaListReducer from "./dealerAddUpdateThanaListReducer";
import dealerAddUpdateUnionListReducer from "./dealerAddUpdateUnionListReducer";
import dealerGetDefaultCurrencyListDealerReducer from "./dealerGetDefaultCurrencyListDealerReducer";
import dealerAddOrUpdateDsrListReducer from "./dealerAddOrUpdateDsrListReducer";
import dealerApproveRejectDsrReducer from "./dealerApproveRejectDsrReducer";
import dealerPendingRequestListReducer from "./dealerPendingRequestListReducer";
import dealerSendInCashInReducer from "./dealerSendInCashInReducer";
import dealerWalletExcelPdfFile from "./dealerWalletExcelPdfFileReducer";
import dealerFeeExcelPdfFileReducer from "./dealerFeeExcelPdfFileReducer";
import dealerSummaryExcelPdfFileReducer from "./dealerSummaryExcelPdfFileReducer";
import dealerCheckListReducer from "./dealerCheckListReducer";

import modifyMerchantReducer from "./modifyMerchantReducer";
import getAccountIdReducer from "./getAccountIdReducer";
import getChargeNameReducer from "./getChargeNameReducer";
import getGatewayAccountListReducer from "./getGatewayAccountListReducer";
import gatewayHistoryReducer from "./gatewayHistoryReducer";
import updateGatewayAccountReducer from "./updateGatewayAccountReducer";
import addGatewayAccountReducer from "./addGatewayAccountReducer";
import dealerCashLiftingListReducer from "./dealerCashLiftingListReducer";
import dealerReqCashLiftingReducer from "./dealerReqCashLiftingReducer";
import dealerBankNameReducer from "./dealerBankNameReducer";
import dealerBranchNameReducer from "./dealerBranchNameReducer";
import dealerGetWithdrawEMoneyListReducer from "./dealerGetWithdrawEMoneyListReducer";
import dealerReqWithdrawEMoneyReducer from "./dealerReqWithdrawEMoneyReducer";
import dealerGetTransactionMasterListReducer from "./dealerGetTransactionMasterListReducer";
import dealerGetFeeReportListreducer from "./dealerGetFeeReportListreducer";
import dealerGetSummaryMasterListReducer from "./dealerGetSummaryMasterListReducer";
import dealerProfileReducer from "./dealerProfileReducer";
import getRoleDropListForDealerReducer from "./getRoleDropListForDealerReducer";

import createGatewayMappingReducer from "./createGatewayMappingReducer";
import getAllGatewayMappingListReducer from "./getAllGatewayMappingListReducer";
import deleteGatewayMappingReducer from "./deleteGatewayMappingReducer";
import getPaymentBrandListReducer from "./getPaymentBrandListReducer";
import getPaymentModeListReducer from "./getPaymentModeListReducer";
import getWayListReducer from "./getWayListReducer";
import dealerGetUserMasterListReducer from "./dealerGetUserMasterListReducer";
import dealerViewUserMasterReducer from "./dealerViewUserMasterReducer";
import { getVoucherWireManagerReducer } from "./getVoucherWireManagerReducer";
import dealerAddEditUserMasterReducer from "./dealerAddEditUserMasterReducer";
import dealerDeleteUserMasterReducer from "./dealerDeleteUserMasterReducer";
import dealerBlockUnblockUserReducer from "./dealerBlockUnblockUserReducer";
import dealerAccountNumberReducer from "./dealerAccountNumberReducer";
import bankBranchListReducer from "./bankBranchListReducer";
import bankNameListReducer from "./bankNameListReducer";
import bankMasterListReducer from "./bankMasterListReducer";
import bankMasterAddUpdateReducer from "./bankMasterAddUpdateReducer";
import bankDistrictListReducer from "./bankDistrictListReducer";
import bankWithdrawEMoneyListReducer from "./bankWithdrawEMoneyListReducer";
import bankWithdrawEMoneyApproveRejectReducer from "./bankWithdrawEMoneyApproveRejectReducer";
import bankCashLiftingListReducer from "./bankCashLiftingListReducer";
import bankCashLiftingApproveRejectReducer from "./bankCashLiftingApproveRejectReducer";
import bankUserManagementAddUpdateReducer from "./bankUseranagementAddUpdateReducer";
import bankUserManagementListReducer from "./bankUserManagementListReducer";
import bankUserManagementDeleteReducer from "./bankUserManagementDeleteReducer";
import bankUserManagementBlockReducer from "./bankUserManagementBlockReducer";
import { updateOrAddVoucherWire } from "./updateOrAddVoucherWireReducer";
import { getAccountIdList } from "./getAccountIdListReducer";
import addChargeMasterReducer from "./addChargeMasterReducer";
import editChargeMasterReducer from "./editChargeMasterReducer";
import addMerchantChargeReducer from "./addMerchantChargeReducer";
import bankMasterViewReducer from "./bankMasterViewReducer";
import generateMerchantWireListReducer from "./generateMerchantWireListReducer";
import blockUnblockReducer from "./blockUnblockReducer";
import deleteUserReducer from "./deleteUserReducer";
import bankRolelistReducer from "./bankRolelistReducer";
import bankUserManagementViewReducer from "./bankUserManagementViewReducer";
import addEditUserReducer from "./addEditUserReducer";
import getMappedListReducer from "./getMappedListReducer";

//partner
import withdrawReqListForPartnerReducer from "./withdrawReqListForPartnerReducer";
import withdrawApproveRejectReducer from "./withdrawApproveRejectReducer";
import cashLiftPartnerReducer from "./cashLiftPartnerReducer";
import cashLiftApproveRejectReducer from "./cashLiftApproveRejectReducer";
import bankNameListPartnerReducer from "./bankNameListPartnerReducer";
import branchNameListPartnerReducer from "./branchNameListPartnerReducer";
import getMappingDealerListReducer from "./getMappingDealerListReducer";
import deleteDealerAgentReducer from "./deleteDealerAgentReducer";
import dealerListPartnerReducer from "./dealerListPartnerReducer";
import editDealerListPartnerReducer from "./editDealerListPartnerReducer";
import divisionListAgentPartnerReducer from "./divisionListAgentPartnerReducer";
import districtListAgentPartnerReducer from "./districtListAgentPartnerReducer";
import thanaListAgentPartnerReducer from "./thanaListAgentPartnerReducer";
import unionListAgentPartnerReducer from "./unionListAgentPartnerReducer";
import getMultipleMappingListForPartnerReducer from "./getMultipleMappingListForPartnerReducer";
import getMultipleSelectForPartnerReducer from "./getMultipleSelectForPartnerReducer";
import viewDealerForPartnerReducer from "./viewDealerForPartnerReducer";
import getRoleDropListForPartnerReducer from "./getRoleDropListForPartnerReducer";
import dealerDsrTransactionExcelPdfFileReducer from "./dealerDsrTransactionExcelPdfFileReducer";
import getModuleMasterListReducer from "./getModuleMasterListReducer";
import adminAddEditMasterModuleReducer from "./adminAddEditMasterModuleReducer";
import TwoFactorFlagsUpdateReducer from "./TwoFactorFlagsUpdateReducer";
import adminGetSubModuleMasterReducer from "./adminGetSubModuleMasterReducer";
import adminADdUpdateSubModuleMasterReducer from "./adminADdUpdateSubModuleMasterReducer";
import adminAddOrUpdateNewCountryReducer from "./adminAddOrUpdateNewCountryReducer";
import adminGetCountryListReducer from "./adminGetCountryListReducer";
import adminCountryMappingListReducer from "./adminCountryMappingListReducer";
import adminGetMappingBankReducer from "./adminGetMappingBankReducer";
import adminDeleteBankMappingReducer from "./adminDeleteBankMappingReducer";
import adminAddLanguageReducer from "./adminAddLanguageReducer";
import adminCountryMappingReducer from "./adminCountryMappingReducer";
import adminGetLanguageListReducer from "./adminGetLanguageListReducer";
import adminGetLanguageMappingListReducer from "./adminGetLanguageMappingListReducer";
import adminMappingLanguageReducer from "./adminMappingLanguageReducer";
import adminGetTransferTypeListReducer from "./adminGetTransferTypeListReducer";
import adminAddUpdateTransferTypeReducer from "./adminAddUpdateTransferTypeReducer";
import adminTransferTypeMappingReducer from "./adminTransferTypeMappingReducer";
import adminGetTransferTypeMappingListReducer from "./adminGetTransferTypeMappingListReducer";
import adminAddUpdateAccountTypeReducer from "./adminAddUpdateAccountTypeReducer";
import adminGetAccountTypeListReducer from "./adminGetAccountTypeListReducer";
import adminAccountTypeMappingReducer from "./adminAccountTypeMappingReducer";
import adminGetAccountTypeMappingReducer from "./adminGetAccountTypeMappingReducer";
import adminAccountTypeMappingDeleteReducer from "./adminAccountTypeMappingDeleteReducer";
import adminDeleteTransferTypeMappingReducer from "./adminDeleteTransferTypeMappingReducer";
import adminGetLanguageDropListReducer from "./adminGetLanguageDropListReducer";
import adminDeleteLanguageMappingReducer from "./adminDeleteLanguageMappingReducer";
import addUpdateAccountTypeAdminReducer from "./addUpdateAccountTypeAdminReducer";
import getAccountTypeAdminReducer from "./getAccountTypeAdminReducer";
import accountTypeMappingAdminReducer from "./accountTypeMappingAdminReducer";
import listAccountTypeMappingReducer from "./listAccountTypeMappingReducer";
import deleteAccountTypeMappingReducer from "./deleteAccountTypeMappingReducer";
import countryListForPartnerReducer from "./countryListForPartnerReducer";
import addNewBankInPartnerReducer from "./addNewBankInPartnerReducer";
import getMappingBankAllListReducer from "./getMappingBankAllListReducer";
import deleteBankMappingForPartnerReducer from "./deleteBankMappingForPartnerReducer";
import getMappingBankNameListReducer from "./getMappingBankNameListReducer";
import bankListForPartnerReducer from "./bankListForPartnerReducer";
import mappingBanksForPartnerReducer from "./mappingBanksForPartnerReducer";
import adminDeleteCountryMappingReducer from "./adminDeleteCountryMappingReducer";
import getUserNameContactSuggestionReducer from "./getUserNameContactSuggestionReducer";
import partnerGetUserNameContactSuggestionReducer from "./partnerGetUserNameContactSuggestionReducer";
import divisioinListPartnerReducer from "./divisioinListPartnerReducer";
import districtListPartnerReducer from "./districtListPartnerReducer";
import thanaListPartnerReducer from "./thanaListPartnerReducer";
import unionListPartnerReducer from "./unionListPartnerReducer";
import adminGetUsernameContactSuggestionReducer from "./adminGetUsernameContactSuggestionReducer";
import adminGetTransactionSubTypeReducer from "./adminGetTransactionSubTypeReducer";
import transactionSubTypesPartnerReducer from "./transactionSubTypesPartnerReducer";
import adminGetCustomerIdAndNameListReducer from "./adminGetCustomerIdAndNameListReducer";
import getTransactionListRefundReducer from "./getTransactionListRefundReducer";
import addUpdateNotificationConfigPartnerReducer from "./addUpdateNotificationConfigPartnerReducer";
import getNotificationConfigPartnerReducer from "./getNotificationConfigPartnerReducer";
import getNotificationConfigAdminReducer from "./getNotificationConfigAdminReducer";
// import { addUpdateNotificationConfigAdminLists } from "../actions/addUpdateNotificationConfigAdminAction";
import addUpdateNotificationConfigAdminReducer from "./addUpdateNotificationConfigAdminReducer";
import getRefundsPartnerReducer from "./getRefundsPartnerReducer";
import getUpdateConfigurationAdminReducer from "./getUpdateConfigurationAdminReducer";
import getViewConfigurationAdminReducer from "./getViewConfigurationAdminReducer";
import getCommonConfigurationAdminReducer from "./getCommonConfigurationAdminReducer";
import getUpdateCommomConfDetailsAdminReducer from "./getUpdateCommomConfDetailsAdminReducer";
import getInquiryReducer from "./getInquiryReducer";
import adminGetInquiryReducer from "./adminGetInquiryReducer";
import adminUpdateGatewayTransactionReducer from "./adminUpdateGatewayTransactionReducer";
import partnerUpdateGatewayTransactionReducer from "./partnerUpdateGatewayTransactionReducer";
import updateWalletTransactionStatusPartnerReducer from "./updateWalletTransactionStatusPartnerReducer";
import updateWalletTransactionStatusAdminReducer from "./updateWalletTransactionStatusAdminReducer";
import adminGetRefundDetailsReducer from "./adminGetRefundDetailsReducer";
import partnerGetRefundDetailsReducer from "./partnerGetRefundDetailsReducer";
import adminAddOrUpdateBusinessNatureSubCategoryReducer from "./adminAddOrUpdateBusinessNatureSubCategoryReducer";
import adminGetBusinessNatureSubCategoryReducer from "./adminGetBusinessNatureSubCategoryReducer";
import adminEditMappingLanguageListReducer from "./adminEditMappingLanguageListReducer";
import businessNatureSubCategoryTypePatnerReducer from "./businessNatureSubCategoryTypePatnerReducer";
import updateKycLabelPartnerReducer from "./updateKycLabelPartnerReducer";
import getKycLabelPartnerReducer from "./getKycLabelPartnerReducer";
import walletTransactionOnParentReducer from "./walletTransactionOnParentReducer";
import adminGetMappingBankListCompareReducer from "./adminGetMappingBankListCompareReducer";
import gateWayListAdminReducer from "./gateWayListAdminReducer";
import adminTransferTypeMappingCompareReducer from "./adminTransferTypeMappingCompareReducer";
import addUpdateSmsProviderAdminReducer from "./addUpdateSmsProviderAdminReducer";
import getSmsProviderAdminReducer from "./getSmsProviderAdminReducer";
import getCustomerIdAndNameAdminListReducer from "./getCustomerIdAndNameAdminListReducer";
import adminCountryMappingCompareListReducer from "./adminCountryMappingCompareListReducer";
import getSmsProviderDropDownAdminReducer from "./getSmsProviderDropDownAdminReducer";
import getWalletTransactionListByIDPartnerReducer from "./getWalletTransactionListByIDPartnerReducer";
import bulkUpdateStatusPartnerReducer from "./bulkUpdateStatusPartnerReducer";
import getWalletTransactionListByIdAdminReducer from "./getWalletTransactionListByIdAdminReducer";
import getUserActivityLogAdminReducer from "./getUserActivityLogAdminReducer";
import getModuleNameListAdmin from "./getModuleNameListAdmin";
import getFeeDetailsByIdPartnerReducer from "./getFeeDetailsByIdPPartnerReducer"
import getSubModuleNameListPartnerReducer from "./getSubModuleListPartnerReducer"
import themeReducer from "./themeReducer";
import verifyQrCodeOtpReducer from "./verifyQrCodeOtpReducer";
import addUpdateSubAdminMgmtAdminReducer from "./addUpdateSubAdminMgmtAdminReducer";
import getSubAdminMgmtListAdminReducer from "./getSubAdminMgmtListAdminReducer";
import viewSubAdminMgmtListAdminReducer from "./viewSubAdminMgmtListAdminReducer";
import getDeleteManagementListAdminReducer from "./getDeleteManagementListAdminReducer";
import blockUnblockSubAdminReducer from "./blockUnblockSubAdminReducer";
import adminModuleMasterListReducer from "./adminModuleMasterListReducer";
import addOrUpdateModuleMasterForAdminReducer from "./addOrUpdateModuleMasterForAdminReducer";
import addOrUpdateSubModuleForAdminReducer from "./addOrUpdateSubModuleForAdminReducer";
import getSubModuleMasterForAdminReducer from "./getSubModuleMasterForAdminReducer";
import getSubAdminDetailsListAdminReducer from "./getSubAdminDetailsListAdminReducer";
import adminGetModuleAllocationListsReducer from "./adminGetModuleAllocationListsReducer";
import adminGetAllocatedModuleListForSubAdminReducer from "./adminGetAllocatedModuleListForSubAdminReducer";
import adminUpdateModuleAllocationListReducer from "./adminUpdateModuleAllocationListReducer";
import getMappedListForAdminReducer from "./getMappedListForAdminReducer";
import adminGetProviderTypeReducer from "./adminGetProviderTypeReducer";
import adminAddIbanProviderReducer from "./adminAddIbanProviderReducer";
import adminGetProviderNameReducer from "./adminGetProviderNameReducer";
import getProvidersAdminReducer from "./getProvidersAdminReducer";
// import { adminMapIBANProviderLists } from "../actions/adminMapIbanProviderAction";
import adminMapIbanProviderReducer from "./adminMapIbanProviderReducer";
import adminGetIbanProviderListReducer from "./adminGetIbanProviderListReducer";
import { getIpWhitelistReducer, addIpWhitelistReducer, deleteIpWhitelistReducer, updateIPwhitelistReducer } from './ipwhitelistreducers';
import updateOrAddCustomerBankDetailsReducer from "./updateOrAddCustomerBankDetailsReducer";
import getCustomerBankDetailsReducer from "./getCustomerBankDetailsReducer";
import getViewCustomerBankDetailsReducer from "./getViewCustomerBankDetailsReducer";
import  {getTransactionCurrencyListReducer}  from './getTransactionCurrencyListReducer';
import createSettlementPartnerReducer from "./createSettlementPartnerReducer";
import getSettlementPartnerReducer from "./getSettlementPartnerReducer";
import downloadSettlementPartnerReducer from "./downloadSettlementPartnerReducer";

import getFeeMarkupReducer from "./getFeeMarkupReducer";
import addFeeMarkupReducer from "./addFeeMarkupReducer";
import updateFeeMarkupReducer from "./updateFeeMarkupReducer";
import getChargebackListReducer from "./getchargebackReducer";
import updateChargebackReducer  from "./updatechargebackReducer"
import uploadtogeneratelinkReducer from "./uploadtogeneratelinkReducer";


const appReducer = combineReducers({
  login: loginReducer,
  logout: logoutReducer,
  forgotPassword: forgotPasswordReducer,
  signup: signupReducer,
  insertOtp: insertOtpReducer,
  sendOtp: sendOtpReducer,
  verifyOtp: verifyOtpReducer,
  showWalletBalance: showWalletBalanceReducer,
  sendMoney: sendMoneyReducer,
  pay: payReducer,
  cashout: cashoutReducer,
  cashin: cashinReducer,
  getreceiver: getReceiverReducer,
  getreceiver: getReceiverReducer,
  userDetails: getUserDetailsReducer,
  payorder: payorderReducer,
  payorderList: payorderListReducer,
  transactionReport: transactionReportReducer,
  payorderOTP: payorderOTPReducer,
  deletePayOrder: deletePayorderReducer,
  verifyPayorder: verifyPayorderReducer,
  getFeeCharge: getFeeChargeReducer,
  requestMoney: requestMoneyReducer,
  transactionHistory: transactionHistReducer,
  operations: operationsReducer,
  loading: loadingReducer,
  profile: profileReducer,
  deleteProfilePic: deleteProfilePicReducer,
  activityLogs: activityLogsReducer,
  changePassword: changePasswordReducer,
  pendingList: pendingListReducer,
  plCount: pendingRequestCountReducer,
  loyaltyPoints: loyaltyPointsReducer,
  redeemLoyaltyPoints: redeemLoyaltyPointsReducer,
  processing: processingReducer,
  getWithdrawDetails: getWithdrawDetailsReducer,
  withdrawMoney: withdrawMoneyReducer,
  paymentMode: getPaymentModesReducer,
  upgradeWallet: upgradeWalletReducer,
  kycDocList: kycDocListReducer,
  loadLimit: loadLimitReducer,
  getKycDetails: getKycDetailsReducer,
  showCards: showCardReducer,
  addCard: cardReducer,
  dashboardDetails: showDashboardDetailsReducer,
  regenerateSecKey: regenerateSecretKeyReducer,
  addBalance: addBalanceReducer,
  currencyConverter: currencyConverterReducer,
  deleteCard: deleteCardReducer,
  changeLanguage: changeLanguageReducer,
  walletSetting: walletSettingReducer,
  currencyList: defaultCurrencyListReducer,
  signupCurrencyList,
  createUpdateWallet: walletReducer,
  getPrepaidCard: getPrepaidCardReducer,
  applyPrepaidCard: applyPrepaidCardReducer,
  walletToWalletTransfer: walletToWalletTransferReducer,
  cardBlockUnblock: cardBlockUnblockReducer,
  directLoad: directLoadReducer,
  bankTransfer: bankTransferReducer,
  loadMoneyToPrepaidCard: loadMoneyToPrepaidCardReducer,
  prepaidCardBalance: prepaidCardBalanceReducer,
  sendCvvBySms: sendCvvBySmsReducer,
  sendPinBySms: sendPinBySmsReducer,
  sendPinByEmail: sendPinByEmailReducer,
  virtualToPhysicalCard: virtualToPhysicalCardReducer,
  cardHolder: cardHolderDetailsReducer,
  prepaidCardStatement: prepaidCardStatementReducer,
  activateCard: activateCardReducer,
  addBank: addBankReducer,
  getBankList: getBankListReducer,
  updateCardDetails: updateCardHolderReducer,
  getWalletRoles: walletRolesReducer,
  walletListDetail: walletListDetailReducer,
  productListDetail: productListReducer,
  addressListDetail: addressListReducer,
  saveAddressDetail: saveAddressReducer,
  addToCart: addProductCartReducer,
  removeFromCart: removeProductCartReducer,
  cartListDetail: cartListReducer,
  marketPlaceCategories: marketPlaceCategoriesReducer,
  bankPayoutDetails: bankPayoutReducer,
  deleteAddress: deleteAddressReducer,
  promoCodes: promoCodeReducer,
  vendorProducts: vendorProductsReducer,
  deleteVendorProduct: deleteVendorProductReducer,
  uploadProduct: uploadProductReducer,
  editVendorProduct: editVendorProductReducer,
  ordersSellReport: ordersSellReportReducer,
  ordersList: ordersListReducer,
  orderStatusChange: orderStatusChangeReducer,
  checkoutLogin: checkoutLoginReducer,
  getPaymentDetails: getCheckoutPaymentDetailsReducer,
  myOrders: myOrdersReducer,
  cancelPurchasedOrder: cancelPurOrderReducer,
  checkoutPayment: checkoutPaymentReducer,
  buyProduct: buyProductReducer,
  feeReport: showDashboardFeeDetailsReducer,
  verifyMobile: verifyMobileReducer,
  cancelCheckoutPayment: cancelCheckoutPaymentReducer,
  bulkUpload: bulkUploadReducer,
  getProfileDetails: getProfileDetailsReducer,
  addOrUpdateBusinessPerson: addOrUpdateBusinessPersonReducer,
  verifyQrUniqueId: verifyQrUniqueIdReducer,
  tpGetDDT: tpGetDDTReducer,
  tpBankList: tpBankListReducer,
  tpBranchList: tpBranchListReducer,
  tpPostalCodes: tpGetPostalCodesReducer,
  frontImageOcr: frontImageOcrReducer,
  backImageOcr: backImageOcrReducer,
  uacs: uacsReducer,

  getMappedList: getMappedListReducer,
  getVoucherRate: voucherRateReducer,
  getmyVouchers: myvoucherReducer,
  getVoucherTransaction: voucherTransactionReducer,
  getVoucherDetails: VoucherDetailsReducer,
  getTransactionDetails: TransactionDetailsReducer,
  voucherDashboardDetails: voucherDashboardDetailsReducer,
  merchantDashboardDetails: merchantDashboardDetailsReducer,
  merchantDashboardPercurrency: merchantDashboardPercurrencyReducer,
  settlementReport: settlementReportReducer,
  settlementDetails: settlementDetailsReducer,
  settlementReportFile: settlementReportFileReducer,
  getGenerateMerchantKey: generateMerchantKeyReducer,
  getGetMerchantKey: getMerchantKeyReducer,
  purchaseVouchers: purchaseVoucherzReducer,
  transactionPasswordSet: transactionPasswordSetReducer,
  setTransactionPassword: setTransactionPasswordReducer,
  changeTransactionPassword: changeTransactionPasswordReducer,
  forgotTransactionPassword: forgotTransactionPasswordReducer,
  transactionRefund: transactionRefundReducer,
  checkoutVoucher: checkoutVoucherReducer,
  loginRole: loginRoleReducer,
  partnerLogin: partnerLoginReducer,
  authToken: authTokenReducer,
  regenerateToken: regenerateTokenReducer,
  adminLogout: adminLogoutReducer,
  modulesForPartner: modulesForPartnerReducer,
  partnerChangePassword: partnerChangePasswordReducer,
  partnerForgotPassword: partnerForgotPasswordReducer,
  customerList: customerListReducer,
  partnerWalletRoles: partnerWalletRolesReducer,
  walletAcRequired: walletAcRequiredReducer,
  individualEntity: individualEntityReducer,
  organizationType: organizationTypeReducer,
  businessType: businessTypeReducer,
  adminCurrencyList: adminCurrencyListReducer,
  legalEntity: legalEntityReducer,
  adminAuthToken: adminAuthTokenReducer,
  getManualDepositList: getManualDepositListReducer,
  addManualAmount: getAddManualAmountReducer,
  getCustomerWalletCurrencyList: getCustomerWalletCurrencyListReducer,
  getLoginBlockList: getLoginBlockListReducer,
  unLockAccount: unLockAccountReducer,
  getCustomerList: getCustomerListReducer,
  getCustomerDetails: getCustomerDetailsReducer,
  updateCustomerDetails: updateCustomerDetailsReducer,
  getOperationList: getOperationListReducer,
  blockCustomerOperations: blockCustomerOperationsListReducer,
  getBlockCustomerOperationsList: getBlockCustomerOperationsListReducer,
  unBlockCustomerOperation: unBlockCustomerOperationReducer,
  getManualOtpList: getManualOtpListReducer,
  closedManualOtpRequestList: closedManualOtpRequestListReducer,
  getKYCAccountTypeList: getKYCAccountTypeListReducer,
  getManualUpgradeKyc: getManualUpgradeKycListReducer,
  sidebarRoute: sidebarReducer,
  approveOrRejectManualUpgradeKYC: approveOrRejectManualUpgradeKYCReducer,
  addNewWalletForCustomer: addNewWalletForCustomerListReducer,
  getAllWalletsList: getAllWalletsListReducer,
  getCustomerIdAndNameList: getCustomerIdAndNameListReducer,
  updateCustomerWalletList: updateCustomerWalletListReducer,
  getCustomerOwnerDetails: getCustomerOwnerDetailsReducer,
  createFeeWallet: createFeeWalletReducer,
  getVoucherMappingList: getVoucherMappingListReducer,
  deleteVoucherMapping: deleteVoucherMappingReducer,
  addNewVoucherMapping: addNewVoucherMappingReducer,
  getVoucherTransactions: getVoucherTransactionListReducer,
  getVoucherTransactionDetails: getVoucherTransactionDetailsListReducer,
  getVoucherList: getVoucherListReducer,
  getvoucherDetails: voucherDetailsReducer,
  getVoucherRedeemList: getVoucherRedeemListReducer,
  getVoucherRedeemDetails: getVoucherRedeemDetailsReducer,
  riskRulesList: riskRulesListReducer,
  updateRiskRule: updateRiskRulesReducer,
  rulesMapping: rulesMappingReducer,
  allowDisallowCountry: allowDisallowCountryReducer,
  getAllowCountryList: getAllowCountryListReducer,
  getBlockCountryList: getBlockCountryListReducer,
  blockUnblockCountry: blockUnblockCountryReducer,
  getCurrencyMasterList: getCurrencyMasterListReducer,
  updateCurrencyMasterList: updateCurrencyMasterListReducer,
  uploadSampleFileOfCurrencyRate: uploadSampleFileOfCurrencyRateReducer,
  downloadSampleFileOfCurrencyRate: downloadSampleFileOfCurrencyRateReducer,
  getWalletTransactionList: getWalletTransactionListReducer,
  getTransactionTypeList: getTransactionTypeListReducer,
  getOperationLogsList: getOperationLogsListReducer,
  gateLoyaltyPointOperationsList: gateLoyaltyPointOperationsListReducer,
  getLoyaltyPointsList: getLoyaltyPointsListReducer,
  createOrUpdateLoyaltyPoint: createOrUpdateLoyaltyPointReducer,
  generateWalletTransactionReportFile:
    generateWalletTransactionReportFileReducer,
  getSummeryReportList: getSummeryReportListReducer,
  getSummeryReportFile: getSummeryReportFileReducer,
  getFeeReportList: getFeeReportListReducer,
  getFeeReportFile: getFeeReportFileReducer,
  getWithdrawLimitList: getWithdrawLimitListReducer,
  addNewWithdrawLimit: addNewWithdrawLimitReducer,
  addOrUpdateUserWithdrawLimit: addOrUpdateUserWithdrawLimitReducer,
  getUserWithdrawLimitList: getUserWithdrawLimitListReducer,
  getWithdrawalCount: getWithdrawalCountReducer,
  getUserWithdrawalCountList: getUserWithdrawalCountReducer,
  updateUserWithdrawCount: updateUserWithdrawCountReducer,
  getLoadLimitList: getLoadLimitListReducer,
  addOrUpdateLoadLimit: addOrUpdateLoadLimtiReducer,
  updateWithdrawalCount: updateWithdrawalCountReducer,
  updateLoadCount: updateLoadCountReducer,
  getFeeManagementList: getFeeManagementListReducer,
  updateFeeManagementList: updateFeeManagementListReducer,
  getWalletDashboard: getWalletDashboardReducer,
  getWayTransactionList: getWayTransactionListReducer,
  viewTransactionDetails: viewTransactionDetailsReducer,
  getWalletOwner: getWalletOwnerReducer,
  deleteWalletOwner: deleteWalletOwnerReducer,
  createOrUpdateWalletOwner: createOrUpdateWalletOwnerReducer,
  getThemeList: getThemeListReducer,
  getBusinessNatureList: getBusinessNatureListReducer,
  getBusinessNatureMappingList: getBusinessNatureMappingListReducer,
  addorUpdateBusinessNature: addorUpadateBusinessNatureReducer,
  getEntityTypeList: getEntityTypeListReducer,
  addOrUpdateEntityTypeList: addOrUpdateEntityTypeListReducer,
  getWalletOwnerIdAndNameList: getWalletOwnerIdAndNameListReducer,
  getEntityMappingList: getEntityMappingListReducer,
  createEntityMapping: createEntityMappingReducer,
  deleteEntityMapping: deleteEntityMappingReducer,
  getRoleList: getRoleListReducer,
  getMappingRoleList: getMappingRoleListReducer,
  createRoleMapping: createRoleMappingReducer,
  deleteRoleMapping: deleteRoleMappingReducer,
  getParentRoleList: getParentRoleListReducer,
  addOrUpdateRole: addOrUpdateRoleReducer,
  getRoleListTable: getRoleListTableReducer,
  getRoleListV1: getRoleListV1Reducer,
  getEntityTypeListTable: getEntityTypeListTableReducer,
  getKycReportList: getKycReportListReducer,
  viewKycDetails: viewKycDetailsReducer,
  adminGetIntegrationType: adminGetIntegrationTypeListReducer,
  adminGetIntegrationList: adminGetIntegrationListReducer,
  adminDeleteIntegration: adminDeleteIntegrationReducer,
  adminAddIntegration: adminAddIntegrationReducer,
  adminGetRiskRuleList: adminGetRiskRuleListReducer,
  adminAddRiskRule: adminAddRiskRuleReducer,
  adminRiskRuleMapping: adminRiskRuleMappingReducer,
  adminCreateRiskRuleMapping: adminCreateRiskRuleMappingReducer,
  adminGetCurrencyMaster: adminGetCurrencyMasterReducer,
  adminAddOrUpdateCurrency: adminAddOrUpdateCurrencyReducer,
  adminCreateCurrencyMapping: adminCreateCurrencyMappingReducer,
  adminGetCurrencyMapping: adminGetCurrencyMappingReducer,
  adminDeleteCurrencyMapping: adminDeleteCurrencyMappingReducer,
  adminGetKycActionType: adminGetKycActionTypeReducer,
  adminGetKycProofList: adminGetKycProofListReducer,
  adminAddOrUpdateKycProof: adminAddOrUpdateKycProofReducer,
  adminGetKycDocumentList: adminGetKycDocumentListReducer,
  adminAddOrUpdateKycDocument: adminAddOrUpdateKycDocumentReducer,
  adminGetFeeMasterList: adminGetFeeMasterListReducer,
  adminGetFeeDefaultValues: adminGetFeeDefaultValuesReducer,
  adminGetFeeOperationType: adminGetFeeOperationTypeReducer,
  adminAddOrUpdateFee: adminAddOrUpdateFeeReducer,
  adminCreateFeeMapping: adminCreateFeeMappingReducer,
  adminGetFeeMapping: adminGetFeeMappingReducer,
  adminAddOrUpdateKycMapping: adminAddOrUpdateKycMappingReducer,
  getKybReportList: getKybReportListReducer,
  getKybDetailsList: getKybDetailsListReducer,
  getKybApproveReject: getKybApproveRejectReducer,
  getWalletOwnerSettingDetails: getWalletOwnerSettingDetailsReducer,
  updateWalletOwnerSettingDetails: updateWalletOwnerSettingDetailReducer,
  createBusinessNatureMapping: createBusinessNatureMappingReducer,
  deleteBusinessNatureMapping: deleteBusinessNatureMappingReducer,
  adminGenerateKey: adminGenerateKeyReducer,
  adminKycMappingList: adminKycMappingListReducer,
  adminLoyaltyPointOperation: adminLoyaltyPointOperationReducer,
  adminGetLoyaltyPoint: adminGetLoyaltyPointReducer,
  adminAddOrUpdateLoyalPoint: adminAddOrUpdateLoyaltyPointReducer,
  getStoreList: getStoreListReducer,
  getBusinessNatureTableList: getBusinessNatureTableListReducer,
  adminModuleAllocation: adminModuleAllocaionReducer,
  adminAllocatedModule: adminAllocatedModuleReducer,

  getUsernameContactSuggestion: getUserNameContactSuggestionReducer,
  adminUpdateModuleAllocation: adminUpdateModuleAllocationReducer,
  adminCurrencyCode: adminCurrencyCodeReducer,
  getWalletOwnerAndNameListApi: getWalletOwnerAndNameListApiReducer,
  getFeeManagementOperationsList: getFeeManagementOperationListReducer,
  getKycConfigurationList: getKycConfigurationListReducer,
  deleteKycConfigurationRecord: deleteKycConfigurationRecordReducer,
  getWalletOwnerBankDetailsList: getWalletOwnerBankDetailsReducer,
  getViewWalletOwnerBankDetails: getViewWalletOwnerBankDetailsReducer,
  updateoraddwalletownerbankdetails: updateoraddwalletownerbankdetailsReducer,
  getViewCongigurationList: getViewCongigurationListReducer,
  getwalletownerconfigurationlist: getwalletownerconfigurationlistReducer,
  getFeeNameList: getFeeNameListReducer,
  getWalletOwnerSmsProvider: getWalletOwnerSmsProviderReducer,
  getKycApproveReject: getKycApproveRejectReducer,
  getInvoice: getInvoiceReducer,
  getUpdateConfiguration: getUpdateConfigurationListReducer,
  commonCfgDetailsList: commonCfgDetailsReducer,
  getUpdateComDetails: getUpdateComDetailsReducer,
  updateInvoiceConfig: updateInvoiceConfigReducer,
  partnerModuleAllocation: partnerModuleAllocationReducer,
  invoiceRegeneration: invoiceRegenerationReducer,
  getInvoiceConfig: getInvoiceConfigReducer,
  getOrderId: getOrderIdReducer,
  getRuleMappingCheck: getRuleMappingCheckReducer,
  addUpdateKycConf: addUpdateKycConfReducer,
  getKycConfigurationDetails: getKycConfigurationDetailsReducer,
  getKycConfigurationId: getKycConfigurationIdReducer,
  getUserManagementlist: getUserManagementListReducer,
  getViewUserManagementlist: getViewUserManagementListReducer,
  getDeleteUserManagementlist: getDeleteUserManagementListReducer,
  createGatewayMapping: createGatewayMappingReducer,
  getAllGatewayMappingList: getAllGatewayMappingListReducer,
  deleteGatewayMapping: deleteGatewayMappingReducer,
  getPaymentBrandList: getPaymentBrandListReducer,
  getPaymentModeList: getPaymentModeListReducer,
  getWayList: getWayListReducer,
  getMerchantWireList: getMerchantWireListReducer,
  editMerchantWire: editMerchantWireReducer,
  getManualSettlement: getManualSettlementReducer,
  getChargeMasterList: getChargeMasterListReducer,
  getMerchantChargeList: getMerchantChargeListReducer,
  merchantHistory: merchantHistoryReducer,
  modifyMerchant: modifyMerchantReducer,
  getAccountId: getAccountIdReducer,
  getChargeName: getChargeNameReducer,
  getGatewayAccountList: getGatewayAccountListReducer,
  gatewayHistory: gatewayHistoryReducer,
  updateGatewayAccount: updateGatewayAccountReducer,
  addGatewayAccount: addGatewayAccountReducer,
  // Dealer
  dealerGetListDsrMaster: dealerGetListDsrMasterReducer,
  dealerGetListDsrTransactionLists: dealerGetListDsrTransactionReducer,
  // dealerGetListDsrTransactionTypeLists: dealerGetTransactionTypeListReducer,
  dealerSetDsrLimits: dealerSetDsrlimitsReducer,
  dealerDsrList: dealerDsrListReducer,
  dealerViewDsrList: dealerViewDsrListReducer,
  dealerUploadDsrLimit: uploadSampleFileOfDealerDsrLimitReducer,
  // dealerDownloadDsrLimit: dealerDownloadSampleFileOfDsrLimitReducer,
  dealerSampleFileLists: dealerSampleFileReducer,
  dealerChangeDsrMasterPassword: dealerChangeDsrMasterPasswordReducer,
  dealerBlockDsrMaster: dealerBlockDsrMasterReducer,
  dealerAddUpdateDsrLimits: dealerAddUpdateDsrLimitsReducer,
  dealerAddUpdateDivisionLists: dealerAddUpdateDivisionListReducer,
  dealerAddUpdateDistrictLists: dealerAddUpdateDistrictListReducer,
  dealerAddUpdateThanaLists: dealerAddUpdateThanaListReducer,
  dealerAddUpdateUnionLists: dealerAddUpdateUnionListReducer,
  dealerGetDefaultCurrencyLists: dealerGetDefaultCurrencyListDealerReducer,
  dealerAddOrUpdateDsrLists: dealerAddOrUpdateDsrListReducer,
  dealerApproveRejectdsrLists: dealerApproveRejectDsrReducer,
  dealerCashLiftingList: dealerCashLiftingListReducer,
  dealerReqCashLifting: dealerReqCashLiftingReducer,
  dealerBankName: dealerBankNameReducer,
  dealerBranchName: dealerBranchNameReducer,
  dealerGetWithdrawEMoneyList: dealerGetWithdrawEMoneyListReducer,
  dealerReqWithdrawEMoney: dealerReqWithdrawEMoneyReducer,
  dealerPendingRequestLists: dealerPendingRequestListReducer,
  dealerGetTransactionMasterLists: dealerGetTransactionMasterListReducer,
  dealerGetFeeReportLists: dealerGetFeeReportListreducer,
  dealerGetSummaryMasterLists: dealerGetSummaryMasterListReducer,
  dealerProfiles: dealerProfileReducer,
  dealerGetUserMasterList: dealerGetUserMasterListReducer,
  dealerViewUserMaster: dealerViewUserMasterReducer,
  getvoucherwiremanager: getVoucherWireManagerReducer,
  updateoraddvoucherwire: updateOrAddVoucherWire,
  getaccoutidlist: getAccountIdList,
  dealerSendInCashInLists: dealerSendInCashInReducer,
  dealerWalletExcelPdfFiles: dealerWalletExcelPdfFile,
  dealerAddEditUserMaster: dealerAddEditUserMasterReducer,
  dealerDeleteUserMaster: dealerDeleteUserMasterReducer,
  dealerBlockUnblockUser: dealerBlockUnblockUserReducer,
  dealerFeeExcelPdfFiles: dealerFeeExcelPdfFileReducer,
  dealerSummaryExcelPdfFiles: dealerSummaryExcelPdfFileReducer,
  dealerAccountNumber: dealerAccountNumberReducer,
  dealerDsrMappingLists: dealerDsrMappingListReducer,
  dealerDeleteDsrList: dealerDeleteDsrReducer,
  dealerAddEditDsrLists: dealerAddEditDsrReducer,
  dealerMultipleMappingLists: dealerMultipleMappingListReducer,
  dealerCheckLists: dealerCheckListReducer,
  dealerAgentDownloadSampleFiles: dealerAgentDownloadSampleFileReducer,
  dealerUploadAgentFiles: dealerUploadAgentFileReducer,
  dealerAgentProfiles: dealerAgentProfileReducer,
  dealerGetRoleDropLists: getRoleDropListForDealerReducer,
  dealerDsrTransactionExcelPdfDataLists:
    dealerDsrTransactionExcelPdfFileReducer,

  //partner
  partnerWithdrawReqListsForPartner: withdrawReqListForPartnerReducer,
  partnerWithdrawApproveRejectLists: withdrawApproveRejectReducer,
  partnerCashLiftLists: cashLiftPartnerReducer,
  partnerCashLiftApproveRejectLists: cashLiftApproveRejectReducer,
  partnerBankNameLists: bankNameListPartnerReducer,
  partnerBranchNameLists: branchNameListPartnerReducer,
  partnerGetMappingDealerLists: getMappingDealerListReducer,
  partnerDeleteDealerLists: deleteDealerAgentReducer,
  partnerDealerLists: dealerListPartnerReducer,
  partnerEditDealerLists: editDealerListPartnerReducer,
  partnerDivisionListAgent: divisionListAgentPartnerReducer,
  partnerDistrictListAgent: districtListAgentPartnerReducer,
  partnerThanaListAgent: thanaListAgentPartnerReducer,
  partnerUnionListAgent: unionListAgentPartnerReducer,
  partnerGetMultipleMappingLists: getMultipleMappingListForPartnerReducer,
  partnerGetMultipleSelectLists: getMultipleSelectForPartnerReducer,
  partnerViewDealerLists: viewDealerForPartnerReducer,
  partnerGetRoleDropLists: getRoleDropListForPartnerReducer,

  bankBranchlist: bankBranchListReducer,
  bankNamelist: bankNameListReducer,
  bankMasterlist: bankMasterListReducer,
  bankMasterview: bankMasterViewReducer,
  bankMasterAddUpdate: bankMasterAddUpdateReducer,
  bankDistrictlist: bankDistrictListReducer,
  bankWithdrawEMoneylist: bankWithdrawEMoneyListReducer,
  bankWithdrawEMoneyApproveReject: bankWithdrawEMoneyApproveRejectReducer,
  bankCashLiftinglist: bankCashLiftingListReducer,
  bankCashLiftingApproveReject: bankCashLiftingApproveRejectReducer,
  bankUserManagementlist: bankUserManagementListReducer,
  bankUserManagementview: bankUserManagementViewReducer,
  bankUserManagementAddUpdate: bankUserManagementAddUpdateReducer,
  bankUserManagementDelete: bankUserManagementDeleteReducer,
  bankUserManagementBlock: bankUserManagementBlockReducer,
  bankRolelist: bankRolelistReducer,
  addChargeMaster: addChargeMasterReducer,
  editChargeMaster: editChargeMasterReducer,
  addMerchantCharge: addMerchantChargeReducer,
  generateMerchantWireList: generateMerchantWireListReducer,
  blockUnblockUser: blockUnblockReducer,
  deleteUser: deleteUserReducer,
  addEditUser: addEditUserReducer,
  getmodulemasterlist: getModuleMasterListReducer,
  addeditmastermodule: adminAddEditMasterModuleReducer,
  flagsupdatedtwofa: TwoFactorFlagsUpdateReducer,
  getsubmodulemaster: adminGetSubModuleMasterReducer,
  addupdatesubmodulemaster: adminADdUpdateSubModuleMasterReducer,
  addOrUpdateNeCountry: adminAddOrUpdateNewCountryReducer,
  getCountryList: adminGetCountryListReducer,
  adminAddNewBanksLists: adminAddNewBankReducer,
  adminGetBanksLists: adminGetBankReducer,
  adminGetBanksNameLists: adminGetBankNameListReducer,
  admincountrymappinglist: adminCountryMappingListReducer,
  adminGetMappingBanksLists: adminGetMappingBankListReducer,
  adminGetMappingsBanks: adminGetMappingBankReducer,
  adminDeleteBanksLists: adminDeleteBankMappingReducer,
  adminAddLanguagLists: adminAddLanguageReducer,
  admincountrymapping: adminCountryMappingReducer,
  adminGetLanguagesLists: adminGetLanguageListReducer,
  adminGetLanguagesDropsLists: adminGetLanguageDropListReducer,
  adminDeleteLanguagesLists: adminDeleteLanguageMappingReducer,
  adminGetLanguagesMappingsLists: adminGetLanguageMappingListReducer,
  adminMappingLanguagesLists: adminMappingLanguageReducer,
  adminGetTransferTypeList: adminGetTransferTypeListReducer,
  adminAddUpdateTransferType: adminAddUpdateTransferTypeReducer,
  adminTransferTypeMapping: adminTransferTypeMappingReducer,
  adminGetTransferTypeMappingList: adminGetTransferTypeMappingListReducer,
  adminAddUpdateAccountType: adminAddUpdateAccountTypeReducer,
  adminGetAccountTypeList: adminGetAccountTypeListReducer,
  adminAccountTypeMapping: adminAccountTypeMappingReducer,
  adminGetAccountTypeMapping: adminGetAccountTypeMappingReducer,
  adminAccountTypeMappingDelete: adminAccountTypeMappingDeleteReducer,
  adminDeleteTransferTypeMapping: adminDeleteTransferTypeMappingReducer,
  addUpdateAccountTypeAdmin: addUpdateAccountTypeAdminReducer,
  getAccountTypeAdmin: getAccountTypeAdminReducer,
  accountTypeMappingAdmin: accountTypeMappingAdminReducer,
  listAccountTypeMapping: listAccountTypeMappingReducer,
  deleteAccountTypeMapping: deleteAccountTypeMappingReducer,
  countryListsForPartner: countryListForPartnerReducer,
  addNewBanksListsInPartner: addNewBankInPartnerReducer,
  getMappingBanksAllLists: getMappingBankAllListReducer,
  deleteBanksMappingsForPartner: deleteBankMappingForPartnerReducer,
  getMappingBanksNamesLists: getMappingBankNameListReducer,
  banksListsForPartner: bankListForPartnerReducer,
  mappingsBankListsForPartner: mappingBanksForPartnerReducer,
  adminDeleteCountryMapping: adminDeleteCountryMappingReducer,
  partnerGetUsernameContactSuggestionsLists:
    partnerGetUserNameContactSuggestionReducer,
  divisionListPartner: divisioinListPartnerReducer,
  districtListPartner: districtListPartnerReducer,
  thanaListPartner: thanaListPartnerReducer,
  unionListPartner: unionListPartnerReducer,
  adminGetUserNameContactSuggestionsLists:
    adminGetUsernameContactSuggestionReducer,
  adminGetTransactionSubTye: adminGetTransactionSubTypeReducer,
  partnerTransactionSubTypesLists: transactionSubTypesPartnerReducer,
  adminGetCustomerIDAndNamesLists: adminGetCustomerIdAndNameListReducer,
  partnerGetTransactionListsRefunds: getTransactionListRefundReducer,
  partnerAddUpdateNotificationConfigsLists:
    addUpdateNotificationConfigPartnerReducer,
  partnerGetConfigNotificationsLists: getNotificationConfigPartnerReducer,
  adminGetnotificationConfigLists: getNotificationConfigAdminReducer,
  addUpdateNotificationConfigurationAdminLists:
    addUpdateNotificationConfigAdminReducer,
  partnerAddUpdateNotificationConfigsLists:
    addUpdateNotificationConfigPartnerReducer,
  partnerGetConfigNotificationsLists: getNotificationConfigPartnerReducer,
  partnerGetRefundList: getRefundsPartnerReducer,
  getUpdateConfigurationAdminList: getUpdateConfigurationAdminReducer,
  getUpdateCommomConfDetailsAdminList: getUpdateCommomConfDetailsAdminReducer,
  getViewConfigurationAdminLists: getViewConfigurationAdminReducer,
  getCommonConfigurationAdminList: getCommonConfigurationAdminReducer,
  partnerGetInquiryLists: getInquiryReducer,
  adminGetInquiryLists: adminGetInquiryReducer,
  adminUpdateGatewayTransactionStatus: adminUpdateGatewayTransactionReducer,
  partnerUpdateGatewayTransactionStatus: partnerUpdateGatewayTransactionReducer,
  partnerUpdateWalletTransactionStatusLists:
    updateWalletTransactionStatusPartnerReducer,
  adminUpdateWalletTransactionStatusList:
    updateWalletTransactionStatusAdminReducer,
  adminGetRefundDetailsList: adminGetRefundDetailsReducer,
  partnerGetRefundDetailsList: partnerGetRefundDetailsReducer,
  adminAddOrUpdateBusinessNatureSubCategoryList:
    adminAddOrUpdateBusinessNatureSubCategoryReducer,
  adminGetBusinessNatureSubCategoryList:
    adminGetBusinessNatureSubCategoryReducer,
  adminEditMappingLanguageLists: adminEditMappingLanguageListReducer,
  businessNatureSubCategoryTypeList: businessNatureSubCategoryTypePatnerReducer,
  partnerUpdateKYCLabelLists: updateKycLabelPartnerReducer,
  partnerGetKYCLablesLists: getKycLabelPartnerReducer,
  getWalletTransactionOnParentList: walletTransactionOnParentReducer,
  adminGetMappingBankListComparesData: adminGetMappingBankListCompareReducer,
  adminGateWayLists: gateWayListAdminReducer,
  adminGetTransferTypeListCompare: adminTransferTypeMappingCompareReducer,

  adminAddUpdateSMSProviderList: addUpdateSmsProviderAdminReducer,
  adminGetSmsProviderSuccessList: getSmsProviderAdminReducer,
  adminGetSmsProviderDropDownList: getSmsProviderDropDownAdminReducer,
  getIpWhitelist: getIpWhitelistReducer,
  addIpWhitelist: addIpWhitelistReducer,
  deleteIpWhitelist: deleteIpWhitelistReducer,
  updateIPwhitelist: updateIPwhitelistReducer,
  getTransactionCurrencyList: getTransactionCurrencyListReducer,

   // ── Chargeback slices (new) ────────────────────────────────────────────────
    getChargebackList:   getChargebackListReducer,   // used as state.getChargebackList
    updateChargeback:    updateChargebackReducer,    // used as state.updateChargeback
    uploadtogeneratelink: uploadtogeneratelinkReducer,

 

  // Fee Markup — NEW ↓
  getFeeMarkupList: getFeeMarkupReducer,
  addFeeMarkup: addFeeMarkupReducer,
  updateFeeMarkup: updateFeeMarkupReducer,

  // adminGetCustomerIdNamesLists: getCustomerIdAndNameAdminListReducer,
  adminGetCustomerIdNamesLists: getCustomerIdAndNameAdminListReducer,
  adminCountryMappingComparesLists: adminCountryMappingCompareListReducer,

  //Partner-Wallet mgmt-Wallet Transaction
  partnerGetWalletTransactionByIdLists: getWalletTransactionListByIDPartnerReducer,
  partnerBulkUpdateStatusLists: bulkUpdateStatusPartnerReducer,

  // 'ADMIN-WALLET MGMT-WALLET TRANSACTION:-ACCORDION'//
  adminGetWalletTransactionByIdLists: getWalletTransactionListByIdAdminReducer,

  // --USER ACTIVITY LOG --//
  adminUserActivityLogList: getUserActivityLogAdminReducer,
  adminGetModuleNameLists: getModuleNameListAdmin,

  partnerGetFeeDetailsById: getFeeDetailsByIdPartnerReducer,

  submodulenamelist: getSubModuleNameListPartnerReducer,
  theme: themeReducer,

  //verifyQrCode OTP
  verifyqrcodeoptList: verifyQrCodeOtpReducer,

  //Admin:-User Mgmt
  adminAddUpdateSubAdminLists: addUpdateSubAdminMgmtAdminReducer,
  adminGetSubAdminMgmtLists: getSubAdminMgmtListAdminReducer,
  adminViewSubAdminMgmtLists: viewSubAdminMgmtListAdminReducer,
  adminGetDeleteAdminMgmtLists: getDeleteManagementListAdminReducer,
  adminBlockUnblockSubAdminLists: blockUnblockSubAdminReducer,
  adminModulesMastersLists: adminModuleMasterListReducer,
  adminAddOrUpdateModuleMasterLists: addOrUpdateModuleMasterForAdminReducer,
  adminAddOrUpdateSubModulesMasterLists: addOrUpdateSubModuleForAdminReducer,
  adminGetSubModulesMasterLists: getSubModuleMasterForAdminReducer,
  adminGetSubadminDetailsLists: getSubAdminDetailsListAdminReducer,
  adminGetModulesAllocationsLists: adminGetModuleAllocationListsReducer,
  adminGetAllocatedModuleslistsSubadmin: adminGetAllocatedModuleListForSubAdminReducer,
  adminUpdateModulesAllocationsLists: adminUpdateModuleAllocationListReducer,
  getMappedListsForadmins: getMappedListForAdminReducer,
  adminGetProviderTypesLists: adminGetProviderTypeReducer,
  adminAddIBANProvidersLists: adminAddIbanProviderReducer,
  adminGetProvidersNamesLists: adminGetProviderNameReducer,
  adminGetProvidersListS: getProvidersAdminReducer,
  adminMapIBANProviderLists: adminMapIbanProviderReducer,
  adminGetIBNProviderLists: adminGetIbanProviderListReducer,
  updateOrAddcustomerbankDetailsLists: updateOrAddCustomerBankDetailsReducer,
  getCustomerbankDetailsLists: getCustomerBankDetailsReducer,
  getViewCustomerBankdetailslists: getViewCustomerBankDetailsReducer,
  createSettlementsReports: createSettlementPartnerReducer,
  getSettlementsReportsData: getSettlementPartnerReducer,
  downloadSettlementReportsData: downloadSettlementPartnerReducer,
});

const rootReducer = (state, action) => {
  if (action.type === LOGOUT_SUCCESS) {
    sessionStorage.removeItem("persist:root");
    // console.log("state", state);
    state = { changeLanguage: state.changeLanguage };
  }
  return appReducer(state, action);
};


export default rootReducer;
